import Api from './Api';

class LogicBaseConversationApi extends Api {
  url = 'logicbaseconversations';
}

const singleton = new LogicBaseConversationApi();
export default singleton;
